const defaultState = {
    token: '',
    authorized: false,
};
export const createAuthSlice = (set) => ({
    auth: defaultState,
    setToken: (token) => set((state) => ({
        auth: {
            ...state.auth,
            token: token,
        },
    })),
    setAuthorized: (authorized) => set((state) => ({
        auth: {
            ...state.auth,
            authorized: authorized,
        },
    })),
});
// Selectors
export const selectAuth = ({ auth: { token, authorized } }) => ({
    token,
    authorized,
});
// Actions
export const selectUpdateAuth = ({ setToken, setAuthorized }) => ({
    setToken,
    setAuthorized,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aFNsaWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3N0YXRlL3NsaWNlcy9hdXRoU2xpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsTUFBTSxZQUFZLEdBQWdCO0lBQ2hDLEtBQUssRUFBRSxFQUFFO0lBQ1QsVUFBVSxFQUFFLEtBQUs7Q0FDbEIsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBa0QsQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdEYsSUFBSSxFQUFFLFlBQVk7SUFDbEIsUUFBUSxFQUFFLENBQUMsS0FBYSxFQUFFLEVBQUUsQ0FDMUIsR0FBRyxDQUFDLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBQ2QsSUFBSSxFQUFFO1lBQ0osR0FBRyxLQUFLLENBQUMsSUFBSTtZQUNiLEtBQUssRUFBRSxLQUFLO1NBQ2I7S0FDRixDQUFDLENBQUM7SUFDTCxhQUFhLEVBQUUsQ0FBQyxVQUFtQixFQUFFLEVBQUUsQ0FDckMsR0FBRyxDQUFDLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBQ2QsSUFBSSxFQUFFO1lBQ0osR0FBRyxLQUFLLENBQUMsSUFBSTtZQUNiLFVBQVUsRUFBRSxVQUFVO1NBQ3ZCO0tBQ0YsQ0FBQyxDQUFDO0NBQ04sQ0FBQyxDQUFDO0FBRUgsWUFBWTtBQUNaLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRyxDQUFDLEVBQUUsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFVBQVUsRUFBRSxFQUFnQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzVFLEtBQUs7SUFDTCxVQUFVO0NBQ1gsQ0FBQyxDQUFDO0FBRUgsVUFBVTtBQUNWLE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLENBQUMsRUFBRSxRQUFRLEVBQUUsYUFBYSxFQUFnQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzlFLFFBQVE7SUFDUixhQUFhO0NBQ2QsQ0FBQyxDQUFDIn0=